import React, { useEffect, useRef, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';
import { useTheme } from '@emotion/react';
import { LoadingButton } from '@mui/lab';
import Iconify from '../iconify/Iconify';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const CreateUserModal = ({ visible = false, dataUpdate, setVisible, fuctGet, isEdit, fuctGetById }) => {
    const { t } = useTranslation();
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addFlag = useRef(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [departments, setDepartments] = useState([]);
    const [department, setDepartment] = useState(null);
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');

    const [email, setemail] = useState('');
    const [phone, setPhone] = useState('');
    const [username, setUsername] = useState('');
    const [RFIDCode, setRFIDCode] = useState('');
    const departmentRef = useRef([]);
    const getRef = useRef(false);
    const getCodeRFIDRef = useRef(false);
    const [flag, setFlag] = useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            getDataDepartment();
        }, 1000);
    }, []);

    useEffect(() => {
        if (isEdit) {
            setName(dataUpdate.user_nm);
            setUsername(dataUpdate.accounts);
            setPhone(dataUpdate.phone);
            setemail(dataUpdate.email);
            setDepartment({
                departs_nm: dataUpdate.departs_nm,
                id: dataUpdate.department_id,
            });
            const filterDeopart = departmentRef.current.filter((item) => item.group_user === dataUpdate.group_user);
            setDepartments(filterDeopart);
            setRFIDCode(dataUpdate.code_rfid || '');
        } else {
            setName('');
            setUsername('');
            setRFIDCode('');
            setPhone('');
            setemail('');
            setPassword('');
            setDepartment({});
            setDepartments(departmentRef.current);
        }
    }, [dataUpdate]);

    const getDataDepartment = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [1];
        sendRequest(serviceList.getAlldepartment, InVal, getDataResultDepartment, true, timeOutFunctDepartment, 40000);
    }, []);

    const getDataResultDepartment = (reqInfoMap, message) => {
        getRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDepartments(message.proc_data.rows[0].o_1);
            departmentRef.current = message.proc_data.rows[0].o_1;
            // console.log(departmentRef.current);
        }
    };

    const timeOutFunctDepartment = (reqInfo) => {
        getRef.current = false;
        toast.error(t('error.time_out'));
    };
    const handleEdit = () => {
        if (addFlag.current === true) return;
        if (!name || !username || !email || !phone || !department) return toast.error(t('error.param'));
        if (!isEdit) {
            if (!password || password.trim() === ' ') {
                toast.error(t('error.pass'));
                return;
            }
        }

        addFlag.current = true;
        setFlagAddStat(true);

        if (isEdit) {
            const InVal = [name, username, email, phone, dataUpdate.id, department.id, RFIDCode];

            sendRequest(serviceList.updatestaff, InVal, actionResult, true, timeOutFunct, 40000);
        } else {
            const InVal = [name, username, email, phone, department.id, btoa(password), RFIDCode];

            sendRequest(serviceList.createstaff, InVal, actionResult, true, timeOutFunct, 40000);
        }
    };

    const actionResult = (reqInfoMap, message) => {
        addFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            if (isEdit) {
                fuctGetById && fuctGetById(dataUpdate.id);
            } else {
                fuctGet && fuctGet();
            }
            setVisible(!visible);
        }
    };

    const timeOutFunct = (reqInfo) => {
        addFlag.current = false;
        setFlagAddStat(false);
        toast.error(t('error.time_out'));
    };

    const getCodeRFID = () => {
        if (getCodeRFIDRef.current) return;
        setFlag(true);
        getCodeRFIDRef.current = true;
        sendRequest(serviceList.getRFID, ['CBNOHN011'], getCodeRFIDResult, true, timeOutFunctIOTCloseCell, 40000, 0);
    };

    const getCodeRFIDResult = (reqInfoMap, message) => {
        setFlag(false);
        getCodeRFIDRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            const codeRFID = message['proc_data'][0] || null;
            if (codeRFID) setRFIDCode(codeRFID);
            else toast.error(t('not_find_rfid_code'));
        }
    };

    const timeOutFunctIOTCloseCell = (reqInfo) => {
        setFlag(false);
        getCodeRFIDRef.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {!isEdit ? t('create_user') : t('update_user')}
            </BootstrapDialogTitle>
            <Loader loading={flagAddStat} />
            <DialogContent dividers>
                <Grid padding={'8px 0'} container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('name_staff')} valueChange={name} getValue={setName} required autoFocus />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput
                            label={t('username')}
                            valueChange={username.toLocaleLowerCase()}
                            required
                            getValue={setUsername}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} sm={9}>
                        <TextInput label={t('RFID_code')} valueChange={RFIDCode} getValue={setRFIDCode} />
                    </Grid>{' '}
                    <Grid item style={{ width: '100%' }} sm={3}>
                        <LoadingButton
                            fullWidth
                            color="inherit"
                            variant="contained"
                            loading={flag}
                            sx={{ height: '40px' }}
                            size="small"
                            loadingPosition="start"
                            onClick={getCodeRFID}
                        >
                            {/* <Iconify icon="entypo:v-card" color="#058373" width={22} height={22} /> */}
                            <Typography variant="button" sx={{ color: flag ? '#999' : '#058373', paddingLeft: 1 }}>
                                {t('get_code_rfid')}
                            </Typography>
                        </LoadingButton>
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput
                            label={t('password')}
                            type="password"
                            disabled={isEdit}
                            valueChange={password}
                            required
                            getValue={setPassword}
                        />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('phone_supplier')} valueChange={phone} getValue={setPhone} required />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <TextInput label={t('Email')} valueChange={email} required getValue={setemail} />
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <ComboBox
                            label={t('department')}
                            valueSelect={department}
                            displayLabel="departs_nm"
                            valueEqual="id"
                            // disabled={isEdit}
                            getValue={setDepartment}
                            selectOption={departments}
                            required
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />

                <ButtonAction onClick={handleEdit} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CreateUserModal;
